import styled from 'styled-components';

export const Container = styled.div`
	flex-basis: 50%;
	flex-grow: 1;
	margin-left: 1px;
`;

export const InputDateContainer = styled.div`
	flex-grow: 1;
	margin-left: 1px;
`;

export const InputTimeContainer = styled.div`
	flex-grow: 1;
`;

export const DateContainer = styled.div`
	margin-bottom: 12px;
`;

export const Wrapper = styled.div`
	margin-bottom: 16px;
`;
